module.exports = __webpack_public_path__ + "static/media/08.ea33b268.mp3";